function CourseRegistrationOverview(params) {
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
}

CourseRegistrationOverview.prototype.switchTab = function(tabType) {
  this.tabType(tabType);
};

module.exports = CourseRegistrationOverview;
